import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';
import { Client } from '../types';

// TIER B (web) — baixa o índice compacto (blob columnar) pela callable `baixarIndiceClientes`, que checa
// ACESSO TOTAL no servidor e lê o blob pelo Admin SDK (a regra do Storage nega leitura direta). Usado pela
// camada "Clientes" do MAPA AO VIVO: quando um acesso-total está no mapa, a carteira dele é a base inteira,
// então em vez de dezenas de queries por codvend baixamos 1 arquivo. Devolve um Client LEVE (projeção — só
// os campos que o mapa precisa: location/nome/codparc/estrelas); a ficha completa é buscada por id no clique.
// Mapeia por NOME de coluna (`cols`) p/ não quebrar se a ordem mudar. null em qualquer falha (o chamador
// cai no caminho por equipe). Espelha mobile/src/services/clientsIndex.ts.
export async function baixarIndiceClientes(): Promise<Client[] | null> {
  try {
    const fn = httpsCallable(functions, 'baixarIndiceClientes', { timeout: 60000 });
    const res: any = await fn();
    const d: any = res?.data;
    if (!d || d.existe === false || !d.indice) return null;
    const cols: string[] = d.indice?.cols;
    const rows: any[][] = d.indice?.rows;
    if (!Array.isArray(cols) || !Array.isArray(rows)) return null;
    const ix = (k: string) => cols.indexOf(k);
    const iId = ix('id'), iName = ix('name'), iTrade = ix('tradeName'), iSeller = ix('sellerId'),
      iCity = ix('city'), iState = ix('state'), iCv = ix('codvend'), iCp = ix('codparc'), iSt = ix('status'),
      iLat = ix('lat'), iLng = ix('lng'), iEst = ix('estrelas');
    if (iId < 0 || iLat < 0 || iLng < 0) return null; // sem coordenada no índice → inútil p/ o mapa
    return rows.map((r) => {
      const lat = r[iLat], lng = r[iLng];
      const cv = iCv >= 0 ? r[iCv] : null, cp = iCp >= 0 ? r[iCp] : null, st = iSt >= 0 ? r[iSt] : null;
      const temSankhya = cv != null || cp != null || st != null;
      // Projeção leve — cast pois só carregamos os campos que o mapa usa (a ficha recarrega o doc por id).
      return {
        id: r[iId],
        name: (iName >= 0 ? r[iName] : '') ?? '',
        tradeName: iTrade >= 0 ? r[iTrade] : undefined,
        sellerId: iSeller >= 0 ? r[iSeller] : undefined,
        active: true,
        estrelas: iEst >= 0 && typeof r[iEst] === 'number' ? r[iEst] : undefined,
        address: { city: iCity >= 0 ? r[iCity] : '', state: iState >= 0 ? r[iState] : '' },
        location: (typeof lat === 'number' && typeof lng === 'number') ? { latitude: lat, longitude: lng } : undefined,
        sankhya: temSankhya ? { codvend: cv, codparc: cp, status: st } : undefined,
      } as unknown as Client;
    });
  } catch {
    return null;
  }
}
